import React from "react";
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard, FlaskConical, Cpu, AlertTriangle, CalendarDays, Settings,
} from "lucide-react";

interface NavItem {
  to: string;
  label: string;
  icon: React.ComponentType<{ size?: number; className?: string }>;
  end?: boolean;
}

// Global, org-scoped navigation. Device drill-down lives inside the Devices
// section (tabs on the device detail page), so the sidebar no longer lists
// individual devices or per-device sub-nav.
const NAV: NavItem[] = [
  { to: "/overview", label: "Overview", icon: LayoutDashboard },
  { to: "/results", label: "Results", icon: FlaskConical },
  { to: "/devices", label: "Devices", icon: Cpu },
  { to: "/alerts", label: "Alerts", icon: AlertTriangle },
  { to: "/schedule", label: "Schedule", icon: CalendarDays },
];

function NavItemLink({ item }: { item: NavItem }) {
  const Icon = item.icon;
  return (
    <NavLink
      to={item.to}
      end={item.end}
      className={({ isActive }) =>
        [
          "group flex items-center gap-sm px-sm h-9 rounded-md text-sm transition-colors",
          isActive
            ? "bg-brand text-white font-medium shadow-sm"
            : "text-text/80 hover:bg-brand/5 hover:text-text",
        ].join(" ")
      }
    >
      {({ isActive }) => (
        <>
          <Icon
            size={16}
            className={isActive ? "text-white" : "text-textLight group-hover:text-brand"}
          />
          <span className="truncate">{item.label}</span>
        </>
      )}
    </NavLink>
  );
}

export function Sidebar() {
  return (
    <aside className="w-56 border-r border-border bg-surface shrink-0 flex flex-col min-h-0">
      <nav className="flex-1 overflow-y-auto p-sm space-y-[2px]">
        {NAV.map((n) => <NavItemLink key={n.to} item={n} />)}
      </nav>
      <div className="border-t border-border p-sm shrink-0">
        <NavItemLink item={{ to: "/account/settings", label: "Settings", icon: Settings }} />
      </div>
    </aside>
  );
}
